export var GdsgInventoryReportRunStatus;
(function (GdsgInventoryReportRunStatus) {
    GdsgInventoryReportRunStatus["GDSG_INVENTORY_REPORT_RUN_STATUS_PENDING"] = "PENDING";
    GdsgInventoryReportRunStatus["GDSG_INVENTORY_REPORT_RUN_STATUS_RUNNING"] = "RUNNING";
    GdsgInventoryReportRunStatus["GDSG_INVENTORY_REPORT_RUN_STATUS_SUCCEEDED"] = "SUCCEEDED";
    GdsgInventoryReportRunStatus["GDSG_INVENTORY_REPORT_RUN_STATUS_FAILED"] = "FAILED";
})(GdsgInventoryReportRunStatus || (GdsgInventoryReportRunStatus = {}));
